import React from 'react';

import { useAppData } from 'src/app/data';
import { NavigationContext, NavigationContextType } from 'src/app/navigation';
import { NavigationWrapper } from 'src/app/navigation-wrapper';
import { getRouteFeaturesFromAppData } from 'src/router/utils/route-features';
import { WorkspaceNavigation } from 'src/sections/workspace/components/navigation/navigation';

const WorkspaceLayout = ({ children }: { children: React.ReactNode }) => {
  const appData = useAppData();
  const { isNavigationRestructureEnabled } =
    getRouteFeaturesFromAppData(appData);

  const navContextValue: NavigationContextType = React.useMemo(
    () => ({
      navigationType: 'product',
      mobileHeading: '',
    }),
    []
  );

  if (isNavigationRestructureEnabled) {
    return (
      <NavigationContext.Provider value={navContextValue}>
        {children}
      </NavigationContext.Provider>
    );
  }

  return (
    <NavigationWrapper Component={WorkspaceNavigation} mobileHeading="">
      {children}
    </NavigationWrapper>
  );
};
export default WorkspaceLayout;
